import { Component, EventEmitter, Input, Output } from "@angular/core";

import { Tile } from "../ng-services/mit-forbrug-indstillinger.model";

@Component({
    selector: "e-forsyning-features-mit-forbrug-tile",
    templateUrl: "./e-forsyning-features-mit-forbrug-tile.component.html",
    styleUrls: ["./e-forsyning-features-mit-forbrug-tile.component.scss"]
})
export class EForsyningFeaturesMitForbrugTileComponent {
    @Input() public tile: Tile;
    @Output() public select = new EventEmitter();

    ngOnInit() {}
}
